import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1rem;
`;

export const listImgsEmpty = styled.div`
	width: 100%;
	height: 200px;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1.5rem;

	> p {
		font-size: 1.4rem;
	}
`;

export const listImgs = styled.div`
	width: 100%;
	height: 200px;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	padding: 1rem;
	overflow: auto;
	gap: 1rem;
`;

export const imgOption = styled.div`
	width: 100%;
	display: flex;
	gap: 1rem;
	padding: 0.8rem;
	border-radius: 5px;
	background-color: ${color.interface.backgroundGray};

	> img {
		max-width: 60px;
		max-height: 60px;
		min-width: 60px;
		min-height: 60px;
		border-radius: 5px;
		background-color: ${color.interface.darkgray2};
	}
`;

export const infos = styled.div`
	width: 100%;
	border-radius: 5px;
	background-color: ${color.interface.backgroundGray};
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	align-items: flex-start;
	justify-content: center;

	> p {
		font-size: 1.3rem;
	}
`;

export const actions = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: row;
	gap: 1rem;

	> svg {
		cursor: pointer;
		font-size: 2.2rem;
		color: ${color.interface.darkgray};
	}
`;
